import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import Rules from './section-components/rules';
import Footer from './global-components/footer-v2';

const Rule = () => {
    return <div>
        <Navbar />
        <PageHeader headertitle="General rules and regulations"  />
        <Rules />
        <Footer />
    </div>
}

export default Rule